<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="card-title">
                    <h3>Activity</h3>
                </div>
                <ms-audit-logs [entityId]="member()?.memberId" [entityType]="AuditEntityType.Member"></ms-audit-logs>
            </div>
        </div>
    </div>
</div>